import * as React from 'react';
import { cn } from '@/lib/utils';

export interface FileFrameProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  title: React.ReactNode;
  children: React.ReactNode;
  titleClassName?: string;
  contentClassName?: string;
  contentPadding?: 'default' | 'none';
}

export const FileFrame = React.forwardRef<HTMLDivElement, FileFrameProps>(
  (
    {
      className,
      titleClassName,
      contentClassName,
      title,
      children,
      contentPadding = 'default',
      ...props
    },
    ref,
  ) => {
    return (
      <div ref={ref} className={cn('w-full', className)} {...props}>
        <div className="pointer-events-none relative z-0 flex justify-end">
          <div className="relative -mb-[9px] h-[34px] w-[180px]">
            <img
              alt=""
              aria-hidden
              className="absolute right-[15px] top-[5px] h-[29px] w-[165px]"
              src="/images/club-ui/rectangle_gray.png"
            />
            <img
              alt=""
              aria-hidden
              className="absolute right-0 top-0 h-[31px] w-[165px]"
              src="/images/club-ui/rectangle_white.png"
            />
            <p
              className={cn(
                'absolute right-0 top-[8px] w-[165px] text-center text-[12px] leading-[1.5] text-club-gray-700',
                titleClassName,
              )}
            >
              {title}
            </p>
          </div>
        </div>

        <div
          className={cn(
            'relative z-10 rounded-bl-[6px] rounded-br-[6px] rounded-tl-[6px] bg-white',
            contentPadding === 'default'
              ? 'px-club-24 pb-club-16 pt-club-24'
              : undefined,
            contentClassName,
          )}
        >
          {children}
        </div>
      </div>
    );
  },
);

FileFrame.displayName = 'FileFrame';
